import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

import { getUserLocation } from "../../redux";
import { useGetAllVendorData } from "../../hooks";
import { VendorsTable } from "../../tables";
import { PageContent } from "../../components";

import VendorsBar from "./VendorsBar";

export const Vendors = ({ defaultLocation = 1 }) => {
  const { search } = useLocation();
  const { isLoading, refetch } = useGetAllVendorData({ defaultLocation });

  useEffect(() => {
    refetch();
  }, [search?.toString()]);

  const props = { defaultLocation };

  return (
    <PageContent gap="10px" isLoading={isLoading} smallPadding hideOverflow>
      <VendorsBar {...props} />
      <VendorsTable {...props} />
    </PageContent>
  );
};

const mapStateToProps = (state) => ({
  defaultLocation: getUserLocation(state),
});
export const VendorsContainer = connect(mapStateToProps)(Vendors);
export default VendorsContainer;
